import {memo} from 'react'
import {getCurrentUserLogin} from '@github-ui/client-env'
import {ForYouItem} from '../../shared/ForYouItem'
import {ForYouLeadingIcon} from '../../shared/ForYouLeadingIcon'
import type {ReviewSummary} from '../../../../../page-data/payloads/review-summaries'
import {getIssueCommentAuthor} from '../util/comment-identity'
import {ReviewDescription} from './ReviewDescription'
import {ReviewTitle} from './ReviewTitle'
import {ReviewContent} from './ReviewContent'
import {REVIEW_STATE_DISPLAY} from '../util/review-state-display'

export const ForYouReviewCommentItem = memo(function ForYouReviewCommentItemComponent({
  reviewSummary,
}: {
  reviewSummary: ReviewSummary
}) {
  const {icon, variant, text} = REVIEW_STATE_DISPLAY[reviewSummary.state]
  // Derive the aria label from the same identity the title renders so the accessible name matches the visible label
  const authorIdentity = getIssueCommentAuthor(reviewSummary.authorLogin, getCurrentUserLogin())

  return (
    <ForYouItem
      key={reviewSummary.id}
      title={<ReviewTitle reviewSummary={reviewSummary} authorIdentity={authorIdentity} />}
      ariaLabel={`${authorIdentity.login} ${text}`}
      itemName={`review-comment--${text}`}
      leadingVisual={<ForYouLeadingIcon icon={icon} variant={variant} />}
      description={<ReviewDescription reviewSummary={reviewSummary} />}
      padding="none"
    >
      {reviewSummary.body.trim().length > 0 && <ReviewContent reviewSummary={reviewSummary} />}
    </ForYouItem>
  )
})
